import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  listPartnerTrackingLink: [],
  listPartnerTrackingStat: [],
  listPartnerCommission: [],
  listPartnerPayment: [],
  listCoupon: [],
  isGetReferralPartnerById: false,
  isGetPartnerTrackingLinks: false,
  isGetPartnerTrackingStats: false,
  isGetPartnerCommission: false,
  isGetPartnerPayment: false,
  isCreatePartnerPayment: false,
  isUpdatePartnerPayment: false,
  isRemovePartnerCommission: false,
  isRemovePartnerPayment: false,
  isGetCoupon: false,
  isCreateCoupon: false,
  isUpdateCoupon: false,
  isRemoveCoupon: false,
  isCreateShortLink: false,
  isAliasAlreadyCreated: false,
  commissionTotal: 0,
  paymentTotal: 0,
  totalEarnedRange: 0,
  totalClawbackRange: 0,
  totalAmountRange: 0,
  totalEarned: 0,
  totalPayment: 0,
  totalClawback: 0,
  w9FormContent: null,
};

export const partnerDetailsSlice = createSlice({
  name: "partner-details",
  initialState,
  reducers: {
    getPartnerTrackingLinksRequest: (state) => {
      state.isGetPartnerTrackingLinks = true;
    },
    getPartnerTrackingLinksSuccess: (state, { payload }) => {
      state.isGetPartnerTrackingLinks = false;
      state.listPartnerTrackingLink = payload;
    },
    getPartnerTrackingLinksFailure: (state) => {
      state.isGetPartnerTrackingLinks = false;
    },
    getPartnerTrackingStatsRequest: (state) => {
      state.isGetPartnerTrackingStats = true;
    },
    getPartnerTrackingStatsSuccess: (state, { payload }) => {
      state.isGetPartnerTrackingStats = false;
      state.listPartnerTrackingStat = payload;
    },
    getPartnerTrackingStatsFailure: (state) => {
      state.isGetPartnerTrackingStats = false;
    },
    getPartnerCommissionRequest: (state) => {
      state.isGetPartnerCommission = true;
    },
    getPartnerCommissionSuccess: (state, { payload }) => {
      state.isGetPartnerCommission = false;
      state.listPartnerCommission = payload.data;
      state.commissionTotal = payload.total;
      state.totalEarnedRange = payload.totalEarned;
      state.totalClawbackRange = payload.totalClawback;
    },
    getPartnerCommissionFailure: (state) => {
      state.isGetPartnerCommission = false;
    },
    getPartnerPaymentRequest: (state) => {
      state.isGetPartnerPayment = true;
    },
    getPartnerPaymentSuccess: (state, { payload }) => {
      state.isGetPartnerPayment = false;
      state.listPartnerPayment = payload.data;
      state.paymentTotal = payload.total;
      state.totalAmountRange = payload.totalAmount;
    },
    getPartnerPaymentFailure: (state) => {
      state.isGetPartnerPayment = false;
    },
    getPartnerSummaryRequest: (state) => {
      state.isGetPartnerSummary = true;
    },
    getPartnerSummarySuccess: (state, { payload }) => {
      state.isGetPartnerSummary = false;
      state.totalEarned = payload.totalEarned;
      state.totalPayment = payload.totalPayment;
      state.totalClawback = payload.totalClawback;
    },
    getPartnerSummaryFailure: (state) => {
      state.isGetPartnerSummary = false;
    },
    createPartnerPaymentRequest: (state) => {
      state.isCreatePartnerPayment = true;
    },
    createPartnerPaymentSuccess: (state, { payload }) => {
      state.isCreatePartnerPayment = false;
      state.paymentTotal += 1;
      message.success("Create payment successfully!");
    },
    createPartnerPaymentFailure: (state) => {
      state.isCreatePartnerPayment = false;
    },
    updatePartnerPaymentRequest: (state) => {
      state.isUpdatePartnerPayment = true;
    },
    updatePartnerPaymentSuccess: (state, { payload }) => {
      state.isUpdatePartnerPayment = false;
      state.listPartnerPayment = payload;
      message.success("Update tracking link successfully!");
    },
    updatePartnerPaymentFailure: (state) => {
      state.isUpdatePartnerPayment = false;
    },
    removePartnerCommissionRequest: (state) => {
      state.isRemovePartnerCommission = true;
    },
    removePartnerCommissionSuccess: (state, { payload }) => {
      state.isRemovePartnerCommission = false;
      message.success("Remove commission earned successfully!");
    },
    removePartnerCommissionFailure: (state) => {
      state.isRemovePartnerCommission = false;
    },
    removePartnerPaymentRequest: (state) => {
      state.isRemovePartnerPayment = true;
    },
    removePartnerPaymentSuccess: (state, { payload }) => {
      state.isRemovePartnerPayment = false;
      message.success("Remove payment made successfully!");
    },
    removePartnerPaymentFailure: (state) => {
      state.isRemovePartnerPayment = false;
    },
    getCouponRequest: (state) => {
      state.isGetCoupon = true;
    },
    getCouponSuccess: (state, { payload }) => {
      state.isGetCoupon = false;
      state.listCoupon = payload;
    },
    getCouponFailure: (state) => {
      state.isGetCoupon = false;
    },
    createCouponRequest: (state) => {
      state.isCreateCoupon = true;
    },
    createCouponSuccess: (state, { payload }) => {
      state.isCreateCoupon = false;
      state.listCoupon.unshift(payload);
      message.success("Create coupon & note successfully!");
    },
    createCouponFailure: (state) => {
      state.isCreateCoupon = false;
    },
    updateCouponRequest: (state) => {
      state.isUpdateCoupon = true;
    },
    updateCouponSuccess: (state, { payload }) => {
      state.isUpdateCoupon = false;
      state.listCoupon = payload;
      message.success("Update coupon & note successfully!");
    },
    updateCouponFailure: (state) => {
      state.isUpdateCoupon = false;
    },
    removeCouponRequest: (state) => {
      state.isRemoveCoupon = true;
    },
    removeCouponSuccess: (state, { payload }) => {
      state.isRemoveCoupon = false;
      state.listCoupon = payload;
      message.success("Remove coupon & note successfully!");
    },
    removeCouponFailure: (state) => {
      state.isRemoveCoupon = false;
    },
    createShortLinkRequest: (state) => {
      state.isCreateShortLink = true;
      state.isAliasAlreadyCreated = false;
    },
    createShortLinkSuccess: (state, { payload }) => {
      state.isCreateShortLink = false;
      state.isAliasAlreadyCreated = false;
      state.listPartnerTrackingLink = payload;
      message.success("Create short link successfully!");
    },
    createShortLinkFailure: (state, { payload }) => {
      if (payload.response.data.code === "ALIAS_CREATED") {
        state.isAliasAlreadyCreated = true;
      }
      state.isCreateShortLink = false;
    },
    getW9FormRequest: (state) => {
      state.isGetW9Form = true;
    },
    getW9FormSuccess: (state, { payload }) => {
      state.isGetW9Form = false;
      state.w9FormContent = payload;
    },
    getW9FormFailure: (state) => {
      state.isGetW9Form = false;
    },
    updateW9FormRequest: (state) => {
      state.isUpdateW9Form = true;
    },
    updateW9FormSuccess: (state, { payload }) => {
      state.isUpdateW9Form = false;
      state.w9FormContent = payload;
      message.success("Update W9-Form success!");
    },
    updateW9FormFailure: (state) => {
      state.isUpdateW9Form = false;
    },
  },
});

export const {
  getPartnerTrackingLinksRequest,
  getPartnerTrackingLinksSuccess,
  getPartnerTrackingLinksFailure,
  getPartnerTrackingStatsRequest,
  getPartnerTrackingStatsSuccess,
  getPartnerTrackingStatsFailure,
  getPartnerCommissionRequest,
  getPartnerCommissionSuccess,
  getPartnerCommissionFailure,
  getPartnerPaymentRequest,
  getPartnerPaymentSuccess,
  getPartnerPaymentFailure,
  getPartnerSummaryRequest,
  getPartnerSummarySuccess,
  getPartnerSummaryFailure,
  createPartnerPaymentRequest,
  createPartnerPaymentSuccess,
  createPartnerPaymentFailure,
  updatePartnerPaymentRequest,
  updatePartnerPaymentSuccess,
  updatePartnerPaymentFailure,
  removePartnerCommissionRequest,
  removePartnerCommissionSuccess,
  removePartnerCommissionFailure,
  removePartnerPaymentRequest,
  removePartnerPaymentSuccess,
  removePartnerPaymentFailure,
  getCouponRequest,
  getCouponSuccess,
  getCouponFailure,
  createCouponRequest,
  createCouponSuccess,
  createCouponFailure,
  updateCouponRequest,
  updateCouponSuccess,
  updateCouponFailure,
  removeCouponRequest,
  removeCouponSuccess,
  removeCouponFailure,
  createShortLinkRequest,
  createShortLinkSuccess,
  createShortLinkFailure,
  getW9FormRequest,
  getW9FormSuccess,
  getW9FormFailure,
  updateW9FormRequest,
  updateW9FormSuccess,
  updateW9FormFailure,
} = partnerDetailsSlice.actions;

export default partnerDetailsSlice.reducer;
